import {HRVSummarySearchRequest} from 'api/analysisApi'
import {
  searchHrvSummary,
  selectError,
  selectItems,
  selectLoading,
  selectPaging,
  selectPagingInfo,
  selectPeriod,
  selectQuery,
  selectSearch,
} from 'features/analysis/hrvSummarySlice'
import {useAppDispatch, useAppSelector} from 'hooks'
import {useLocation, useHistory} from 'react-router-dom'

export default function useHrvSummary() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const history = useHistory()

  const loading = useAppSelector(selectLoading)
  const error = useAppSelector(selectError)
  const items = useAppSelector(selectItems)

  const period = useAppSelector(selectPeriod)
  const paging = useAppSelector(selectPaging)
  const pagingInfo = useAppSelector(selectPagingInfo)
  const search = useAppSelector(selectSearch)
  const query = useAppSelector(selectQuery)

  const onSearch = (payload: HRVSummarySearchRequest) => {
    try {
      const params = new URLSearchParams(
        Object.entries(payload).map(([key, value]) => [
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        ]),
      )
      history.replace({pathname: location.pathname, search: params.toString()})
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
    dispatch(searchHrvSummary(payload))
  }

  return {
    loading,
    error,
    items,
    period,
    paging,
    pagingInfo,
    search,
    query,
    onSearch,
  }
}
